import React, { useState, memo, useCallback } from 'react'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import { withStyles } from '@material-ui/core/styles'

import ColumnHeader from './ColumnHeader'
import ColumnItem from './ColumnItem'

import style from './style'

function PipelineColumn({
  items,
  name,
  classes,
  url,
  onDelete,
  onExportData,
  onMailClick,
  onDocumentsModalOpen,
  onApprovedModalOpen,
  onAttendantUpdate,
  isLoading,
  isESCountry,
}) {
  const [filtered, setFiltered] = useState()

  const exportColumn = useCallback(() => {
    onExportData(filtered || items)
  }, [filtered, items])

  return (
    <Droppable droppableId={name}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          className={classes.list}
          cypress_id={'pipelineColumn: ' + name}
        >
          <ColumnHeader
            name={name}
            setFiltered={setFiltered}
            exportColumn={exportColumn}
            onMailClick={onMailClick}
            items={items}
            isLoading={isLoading}
            count={items.length}
          />
          {(filtered || items).map((item, index) => (
            <Draggable key={item.id} draggableId={item.id} index={index}>
              {(provided, snapshot) => (
                <ColumnItem
                  provided={provided}
                  snapshot={snapshot}
                  item={item}
                  columnName={name}
                  url={url}
                  name={name}
                  onDelete={onDelete}
                  onDocumentsModalOpen={onDocumentsModalOpen}
                  onApprovedModalOpen={onApprovedModalOpen}
                  onAttendantUpdate={onAttendantUpdate}
                  isESCountry={isESCountry}
                />
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  )
}

export default memo(withStyles(style)(PipelineColumn))
